import DoughnutWithContentAndFill from './DoughnutWithContentAndFill';

export default DoughnutWithContentAndFill;
